module.exports = __webpack_public_path__ + "img/8.01df9c17.jpg";